import _classCallCheck from "/builds/orgs/oranjefonds/nldoet.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/orgs/oranjefonds/nldoet.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import qs from 'qs';
export var defaultCreateURL = function defaultCreateURL(_ref) {
  var qsModule = _ref.qsModule,
    routeState = _ref.routeState,
    location = _ref.location;
  if (location) {
    var protocol = location.protocol,
      hostname = location.hostname,
      _location$port = location.port,
      port = _location$port === void 0 ? '' : _location$port,
      pathname = location.pathname,
      hash = location.hash;
    var queryString = qsModule.stringify(routeState);
    var portWithPrefix = port === '' ? '' : ":".concat(port);
    // IE <= 11 has no proper `location.origin` so we cannot rely on it.
    if (!queryString) {
      return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
    }
    return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
  }
  return "?".concat(qsModule.stringify(routeState));
};
export var defaultParseURL = function defaultParseURL(_ref2) {
  var qsModule = _ref2.qsModule,
    location = _ref2.location;
  return qsModule.parse(location.search.slice(1), {
    arrayLimit: 99
  });
};
var BrowserHistory = /*#__PURE__*/function () {
  function BrowserHistory() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$writeDelay = _ref3.writeDelay,
      writeDelay = _ref3$writeDelay === void 0 ? 400 : _ref3$writeDelay,
      _ref3$createURL = _ref3.createURL,
      createURL = _ref3$createURL === void 0 ? defaultCreateURL : _ref3$createURL,
      _ref3$parseURL = _ref3.parseURL,
      parseURL = _ref3$parseURL === void 0 ? defaultParseURL : _ref3$parseURL;
    _classCallCheck(this, BrowserHistory);
    this.writeTimer = undefined;
    this.writeDelay = writeDelay;
    this._createURL = createURL;
    this._parseURL = parseURL;
  }
  _createClass(BrowserHistory, [{
    key: "read",
    value: function read() {
      return this._parseURL({
        qsModule: qs,
        location: window.location
      });
    }
  }, {
    key: "write",
    value: function write(routeState) {
      var _this = this;
      var shouldPushToHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var url = this.createURL(routeState);
      if (this.writeTimer) {
        window.clearTimeout(this.writeTimer);
      }
      this.writeTimer = window.setTimeout(function () {
        if (shouldPushToHistory) {
          window.history.pushState(routeState, null, url);
        }
        _this.writeTimer = undefined;
      }, this.writeDelay);
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(callback) {
      var _this2 = this;
      this._onPopState = function (event) {
        if (_this2.writeTimer) {
          window.clearTimeout(_this2.writeTimer);
          _this2.writeTimer = undefined;
        }
        var routeState = event.state;
        if (!routeState) {
          callback(_this2.read());
        } else {
          callback(routeState);
        }
      };
      window.addEventListener('popstate', this._onPopState);
    }
  }, {
    key: "createURL",
    value: function createURL(routeState) {
      return this._createURL({
        qsModule: qs,
        routeState: routeState,
        location: window.location
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._onPopState) {
        window.removeEventListener('popstate', this._onPopState);
      }
      if (this.writeTimer) {
        window.clearTimeout(this.writeTimer);
      }
      this.write({}, false);
    }
  }]);
  return BrowserHistory;
}();
export default function (props) {
  return new BrowserHistory(props);
}